import React from "react";
import { NavLink } from "react-router-dom";
import { ROUTES } from "../routes/routes";

export default function Footer() {
    return (
        <footer>
            <div className="footer-container">
                <ul className="footer-links">
                    <li className="foot-item">
                        <NavLink to={ROUTES.home.path}>Home</NavLink>
                    </li>
                    <li className="foot-item">
                        <NavLink to={ROUTES.blog.path}>Blog</NavLink>
                    </li>
                    <li className="foot-item">
                        <NavLink to={ROUTES.project.path}>Projects</NavLink>
                    </li>
                </ul>
                <div className="footer-text">
                    <div className="footer-contact">
                        <h4>Graduaat Programmeren</h4>
                        <p>info@arteveldehs.be</p>
                    </div>
                </div>
            </div>
        </footer>
    );
}
